
import Vue from 'vue';

export default {
  name: 'AppFormLegacy',
  model: { prop: 'formObject', event: 'change' },
  props: {
    formObject: { type: Object, required: true },
    objectId: { type: String, required: true },
    fields: {
      type: Array,
      required: true,
      validator: fields =>
        fields.length && fields.every(f => ['key', 'type'].every(k => f[k]))
    },
    eventBus: { type: Object, default: () => new Vue() },
    focusFieldKey: { type: String, default: '' }
  },
  data() {
    return { fieldErrors: {} };
  },
  watch: {
    fieldErrors: {
      handler() {
        this.$emit('field-errors', this.fieldErrors);
      },
      deep: true
    }
  },
  created() {
    this.eventBus.$on('submit', () => this.submit());
    this.eventBus.$on('validate-field', key => this.validateField(key));
  },
  methods: {
    onChangeField(key, value) {
      this.$emit('change', { ...this.formObject, [key]: value });
    },
    submit() {
      this.$emit('submit', new FormData(this.$el));
    },
    fieldComponent(fieldType) {
      switch (fieldType) {
        case 'text':
          return 'AppTextInput';
        case 'password':
          return 'AppPasswordInput';
        case 'textarea':
          return 'AppTextareaLegacy';
        case 'select':
          return 'AppSelect';
        default:
          throw `Undefined field type ${fieldType}`;
      }
    },
    validateField(key) {
      this.$delete(this.fieldErrors, key);

      const validators = this.fields.find(v => v.key === key).validators;
      for (const validator of validators) {
        if (!validator.rule(this.formObject[key])) {
          this.$set(this.fieldErrors, key, { message: validator.message });
          break;
        }
      }
    }
  }
};
